// extracted by mini-css-extract-plugin
export default {"container":"styles_container__dsAUm","logo":"styles_logo__nh4pA","buttons":"styles_buttons__EwIav","button":"styles_button__LfhAw"};